function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "path-1",
  cx: 128,
  cy: 128,
  r: 128
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "iOS-App-Icon-Template",
  transform: "translate(-1681.000000, -325.000000)"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  id: "Background",
  fill: "#FFFFFF",
  x: -1,
  y: 0,
  width: 512,
  height: 512
});

var _ref7 = /*#__PURE__*/React.createElement("use", {
  stroke: "#007AFF",
  strokeWidth: 18,
  xlinkHref: "#path-1"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M207.46938,262.904121 L352.374286,263.692534 C357.262305,263.719129 359.032372,264.235264 360.816095,265.197411 C362.599819,266.159558 363.998178,267.565546 364.950606,269.354478 C365.903034,271.143411 366.409531,272.916259 366.409531,277.804351 L366.409531,288.909937 C366.409531,293.81329 365.89899,295.591364 364.940301,297.383957 C363.981612,299.176549 362.574775,300.583387 360.782182,301.542076 C358.989589,302.500765 357.211515,303.011305 352.308162,303.011305 L210.510899,303.011305 C205.607546,303.011305 203.829472,302.500765 202.036879,301.542076 C200.244287,300.583387 198.83745,299.176549 197.878761,297.383957 C196.920072,295.591364 196.409531,293.81329 196.409531,288.909937 L196.409531,273.903959 C196.409531,267.828826 201.334398,262.903959 207.409531,262.903959 C207.42948,262.903959 207.44943,262.904013 207.46938,262.904121 Z",
  id: "Rectangle",
  fill: "#007AFF",
  transform: "translate(281.409531, 283.011305) rotate(45.000000) translate(-281.409531, -283.011305) "
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#00CFDB",
  x: 120,
  y: 56,
  width: 19,
  height: 140,
  rx: 9.5
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#00CFDB",
  x: 160,
  y: 78,
  width: 19,
  height: 100,
  rx: 9.5
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#00CFDB",
  x: 205,
  y: 108,
  width: 19,
  height: 40,
  rx: 9.5
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#00CFDB",
  x: 80,
  y: 78,
  width: 19,
  height: 100,
  rx: 9.5
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#00CFDB",
  x: 40,
  y: 110,
  width: 19,
  height: 40,
  rx: 9.5
});

var _ref14 = /*#__PURE__*/React.createElement("g", {
  id: "Smooth-Corners",
  opacity: 0,
  fill: "#000000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-3.93619317e-15,365.858544 C2.28704159e-15,416.675112 5.29105984,435.102427 15.2265641,453.680205 C25.1620684,472.257983 39.7420171,486.837932 58.3197949,496.773436 C76.8975727,506.70894 95.3248882,512 146.141456,512 L146.141456,512 L0,512 Z M512,365.858544 L512,512 L365.858544,512 C416.675112,512 435.102427,506.70894 453.680205,496.773436 C472.257983,486.837932 486.837932,472.257983 496.773436,453.680205 C506.70894,435.102427 512,416.675112 512,365.858544 L512,365.858544 Z M512,146.141456 C512,95.3248882 506.70894,76.8975727 496.773436,58.3197949 C486.837932,39.7420171 472.257983,25.1620684 453.680205,15.2265641 C435.102427,5.29105984 416.675112,-3.43056238e-15 365.858544,5.90428975e-15 L365.858544,5.90428975e-15 L512,0 Z M0,0 L146.141456,-5.90428975e-15 C95.3248882,3.43056238e-15 76.8975727,5.29105984 58.3197949,15.2265641 C39.7420171,25.1620684 25.1620684,39.7420171 15.2265641,58.3197949 C5.29105984,76.8975727 -2.28704159e-15,95.3248882 3.93619317e-15,146.141456 L3.93619317e-15,146.141456 L0,0 Z"
}));

var SvgPacketFlyIcon = function SvgPacketFlyIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, _ref5, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, _ref6, /*#__PURE__*/React.createElement("g", {
    id: "Glyph",
    transform: "translate(80.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0,
    fill: "#000000",
    fillRule: "evenodd",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-1"
  }), _ref7), _ref8, _ref9, _ref10, _ref11, _ref12, _ref13), _ref14)));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPacketFlyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PacketFlyIcon.63351251.svg";
export { ForwardRef as ReactComponent };